module.exports = __webpack_public_path__ + "img/category_12.111280d1.png";